import config from 'constants/config'
import { OptimizelyClientSideExperiments, useOptimizelyExperiment } from 'lib/optimizely/optimizelyUtils'
import { useIsLargeDesktopScreen } from 'lib/web/deviceUtils'

const useSearchSplitView = () => {
  const isDesktop = useIsLargeDesktopScreen()
  const isSplitViewEnabled = config.ENABLE_SEARCH_SPLIT_VIEW

  const isExperimentEnabled = !!useOptimizelyExperiment(OptimizelyClientSideExperiments.searchMapSplitView)

  return isDesktop && isSplitViewEnabled && isExperimentEnabled
}

export default useSearchSplitView
